import { combineReducers } from 'redux'

import inventoryForecast from './inventory_forecast'

export default combineReducers({
  inventoryForecast
})
